import { datadogRum } from '@datadog/browser-rum';
import axios from 'axios';
import Cookies from 'js-cookie';

type Props = {
  experimentName: string;
  identifier: string;
  apiTimeout?: number;
  cacheMinutes?: number;
};

type Response = {
  content: {
    experimentName: string;
    bucketKey: string;
  };
};

const FetchExperimentWithIdentifier = ({
  experimentName,
  identifier,
  apiTimeout,
  cacheMinutes
}: Props) =>
  axios
    .post<Response>(
      `${process.env.SPLITTEST_API_URL}/api/v2/buckets`,
      {
        experimentName,
        identifier
      },
      { timeout: apiTimeout }
    )
    .then(({ data: { content: { bucketKey = null } = {} } = {} }) => {
      if (cacheMinutes !== 0 && bucketKey) {
        Cookies.set(experimentName, bucketKey, {
          expires: new Date(new Date().getTime() + cacheMinutes * 60 * 1000)
        });
      }

      const experimentObject = {
        assignedBucket: bucketKey,
        experimentName,
        hasErrors: false
      };
      datadogRum.addAction('user-bucketed', {
        experimentName,
        bucketKey
      });

      return experimentObject;
    })
    .catch(() => {
      return {
        assignedBucket: null,
        experimentName,
        hasErrors: true
      };
    });

export default FetchExperimentWithIdentifier;
